var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('ViewBalance',{key:_vm.componentKey,attrs:{"balance-data":_vm.data},on:{"ready":_vm.getData,"reload":_vm.getData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }